import normalize from "json-api-normalizer";
import store from "@/store/index";

import BaseService from "./BaseService";

export default {
  list() {
    return BaseService.get("care_templates").then(response => {
      const templates = normalize(response.data).careTemplates;
      store.dispatch("careTemplate/setList", templates);
    });
  },

  create(values) {
    return BaseService.post("care-templates", "care_templates", values)
      .then(response => {
        const template = normalize(response.data).careTemplates;
        store.dispatch("careTemplate/add", template);
      })
      .catch(errors => Promise.reject(errors));
  }
};
